export enum MutationTypes {
  "IS_LOGGED_IN" = "IS_LOGGED_IN",
  "CHANGE_VIEW_TYPE" = "CHANGE_VIEW_TYPE"
}
